import extend from 'lodash/extend';
import each from 'lodash/each';

export class Size {
    constructor(size, weight = 0, merchant_cost = 0, additional_domestic_shipping_costs = 0, additional_international_shipping_costs = 0) {
        this.size = size;
        this.weight = weight;
        this.merchant_cost = merchant_cost;
        this.additional_domestic_shipping_costs = additional_domestic_shipping_costs;
        this.additional_international_shipping_costs = additional_international_shipping_costs;
        this.key = Math.random();
    }
};

export class Product {
    constructor(product) {
        if (product) {
            extend(this, product);
        } else {
            this.back_image = '';
            this.back_mask = '';
            this.brand = '';
            this.front_image = '';
            this.front_mask = '';
            this.product_group = '';
            this.product_type = '';
            this.sku = '';
            this.sizes = [new Size('OS')];
            this.colors = [];
            this.base_price = null;
            this.actual_cost = null;
        }

        this.frontImage = null;
        this.frontMask = null;
        this.backImage = null;
        this.backMask = null;

        this.frontImageUri = null;
        this.frontMaskUri = null;
        this.backImageUri = null;
        this.backMaskUri = null;
    }
};

export class Color {
    constructor(name, hex, sizes) {
        let overrides = [];

        each(sizes, size => {
            overrides.push({
                size: size.size,
                printer_id: null,
            });
        });

        this.name = name;
        this.hex = hex;
        this.active = false;
        this.product_color_size_overrides = overrides;
    }
}
